module.exports = __webpack_public_path__ + "static/img/banner.32c35738.jpg";